import { Icon } from '~/models/common/types'
import { ciCheck } from '~/icons/source/solid/check'

export const solidFallbackIcon: Icon = {
  icon: ciCheck
}
